module.exports = __webpack_public_path__ + "static/10-5daa4ff58465abf0abc874ca61e0ab29.jpg";